const riparazioni_clienti = {
    state: {
        component: 'Index',
        edit: false,
        all: []
    },
    mutations: {
        CHANGE_RIPARAZIONI_CLIENTI_COMPONENT(state, payload) {
            state.component = payload
        },
        CHANGE_RIPARAZIONI_CLIENTI_EDIT(state, payload) {
            state.edit = payload
        }
    },
    getters: {
        getRiparazioniClientiComponent: state => state.component,
        getRiparazioniClientiEdit: state => state.edit
    }
}

export default riparazioni_clienti